// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-main-template-js": () => import("./../../../src/templates/MainTemplate.js" /* webpackChunkName: "component---src-templates-main-template-js" */)
}

